import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
    }),
    surveyLink() {
      return `${import.meta.env.VITE_SURVEY_MONKEY_URI}?legacyId=${this.currentUser.id}`;
    },
  },
  methods: {
    handleSurveyClicked() {
      window.open(this.surveyLink, '_blank');
    },
  },
};
